import { Box } from '@dtx-company/design-system/src'
import { CustomFooter } from './footer/minimal'
import { CustomHead } from '../head'
import { GlobalLayout } from './styles'
import { Meta } from '../../constants/meta'
import { UnauthSlot } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { WhiteLabelFooter } from './footer/WhiteLabelFooter/WhiteLabelFooter'
import { useCanonicalURL } from '@app/common/src/hooks/useCanonicalURL'
import { useRouter } from 'next/router'
import React from 'react'
import dynamic from 'next/dynamic'

/* istanbul ignore next */
const MinimalFooter = dynamic<{ route?: string }>(() =>
  import('./footer/minimal').then(mod => mod.MinimalFooter)
)

/* istanbul ignore next */
const Footer = dynamic<Record<string, unknown>>(() => import('./footer').then(mod => mod.Footer))

export const FlowpageContainer = ({
  children,
  page,
  injectedMeta,
  minimalFooter,
  customFooter,
  whiteLabelFooter
}: {
  children: React.ReactNode
  page: string
  injectedMeta?: Meta
  minimalFooter?: boolean
  customFooter?: UnauthSlot
  whiteLabelFooter?: boolean
}): JSX.Element => {
  const canonicalURL = useCanonicalURL()
  const router = useRouter()

  return (
    <GlobalLayout disableTopNav navHeight={0} disableSideNav>
      <CustomHead
        injectedMeta={{
          canonical: canonicalURL,
          ...injectedMeta
        }}
        page={page}
      />
      <Box
        sx={{
          gridArea: 'content',
          maxWidth: '100vw'
        }}
      >
        {children}
      </Box>
      {!minimalFooter && !customFooter && !whiteLabelFooter && <Footer disableSideNav />}
      {minimalFooter && !customFooter && !whiteLabelFooter && (
        <MinimalFooter route={router.asPath} />
      )}
      {customFooter && <CustomFooter customFooter={customFooter} />}
      {whiteLabelFooter && !customFooter && <WhiteLabelFooter />}
    </GlobalLayout>
  )
}
